import { render } from "./AllAdmins.vue?vue&type=template&id=6362220a&scoped=true"
import script from "./AllAdmins.vue?vue&type=script&lang=js"
export * from "./AllAdmins.vue?vue&type=script&lang=js"

import "./AllAdmins.vue?vue&type=style&index=0&id=6362220a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6362220a"]])

export default __exports__